import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JsonToStringPipe } from './jsonToString-pipe';
import { PrettyJsonGridPipe } from './prettyJsonGrid-pipe';
import { HighlightSearchPipe } from './searchText-pipe';

@NgModule({
  declarations: [JsonToStringPipe, PrettyJsonGridPipe, HighlightSearchPipe],
  imports: [CommonModule],
  exports: [JsonToStringPipe, PrettyJsonGridPipe, HighlightSearchPipe],
})
export class HelpersModule {}
